export const FieldDivider = () => {
  return <div className="mb-5 h-px bg-border-secondary last:mb-0" />
}
